import Dinero from 'dinero.js';
import { ref } from 'vue'

type AdditionalDamage = {
  price: Dinero.Dinero;
  paidBy: typeof invoiceOptions[number];
}

interface Form {
  rerouting: {
    reRoutedAtAirlineExpense: typeof booleanOptions[number];
    newTicket: AdditionalDamage;
    nextFlightOption: typeof nextFlightOptions[number];
  },
  additionalExpenses: AdditionalDamage;
  accommodationDutyOption: typeof accommodationDutyOptions[number];
  additionalAccommodation: AdditionalDamage;
  lostAccommodation: AdditionalDamage;
  totalOtherLoss: AdditionalDamage;
  cause: typeof causesOptions[number];
  note?: string;
}
  
const booleanOptions = [
  { value: true, label: "Oui" },
  { value: false, label: "Non" },
]
  
type InvoiceOption = "TRAVEL_AGENCY_LOSS" | "ENTERPRISE_ACCOUNT";
export const invoiceOptions: Array<{ value: InvoiceOption; label: string; }> = [
  { value: "TRAVEL_AGENCY_LOSS", label: "Perte agence" },
  { value: "ENTERPRISE_ACCOUNT", label: "Facturé sur le compte de l'entreprise" },
];
  
type NextFlightOption = "UNKNOWN" | "SAME_DAY" | "NEXT_DAY_OR_LATER" | "NO_NEXT_FLIGHT";
export const nextFlightOptions: Array<{ value: NextFlightOption; label: string; }> = [
  { value: "UNKNOWN", label: "Je ne sais pas" },
  { value: "SAME_DAY", label: "Nouveau vol le jour même" },
  { value: "NEXT_DAY_OR_LATER", label: "Nouveau vol le lendemain ou plus tard" },
  { value: "NO_NEXT_FLIGHT", label: "Pas eu de nouveau vol" },
];
  
type AccommodationDutyOption = "ADDITIONAL_ACCOMMODATION" | "PASSENGERS_SLEPT_AT_AIRPORT" | "OTHER_NO_COSTS" | "UNKNOWN";
export const accommodationDutyOptions: Array<{ value: AccommodationDutyOption; label: string; }> = [
  { value: "ADDITIONAL_ACCOMMODATION", label: "Le passager a dormi a l'hotel" },
  { value: "PASSENGERS_SLEPT_AT_AIRPORT", label: "Le passager a dormi a l’aéroport" },
  { value: "OTHER_NO_COSTS", label: "Le passager s’est débrouillé et n’a rien déboursé" },
  { value: "UNKNOWN", label: "Je ne sais pas" },
 ];
  
type CauseOption = "WEATHER" | "TECHNICAL_INCIDENT" | "AIRPORT_ISSUES" | "STRIKE" | "UNKNOWN" | "OTHER";
export const causesOptions: Array<{ value: CauseOption; label: string; }> = [
  { value: "WEATHER", label: "Météo" },
  { value: "TECHNICAL_INCIDENT", label: "Incident technique" },
  { value: "AIRPORT_ISSUES", label: "Problèmes à l'aéroport" },
  { value: "STRIKE", label: "Grève" },
  { value: "UNKNOWN", label: "Je ne sais pas" },
  { value: "OTHER", label: "Autre (merci d'indiquer dans la note)" },
];
  
export const defaulPrice = Dinero({ amount: 0, currency: "EUR", precision: 2 });
  
export const form = ref<Form>({
  rerouting: {
    reRoutedAtAirlineExpense: booleanOptions[1],
    newTicket: {
      price: defaulPrice,
      paidBy: invoiceOptions[1],
    },
    nextFlightOption: nextFlightOptions[0],
  },
  accommodationDutyOption: accommodationDutyOptions[3],
  additionalAccommodation: {
    price: defaulPrice,
    paidBy: invoiceOptions[1], 
  },
  additionalExpenses: {
    price: defaulPrice,
    paidBy: invoiceOptions[1], 
  },
  lostAccommodation: {
    price: defaulPrice,
    paidBy: invoiceOptions[1], 
  },
  totalOtherLoss: {
    price: defaulPrice,
    paidBy: invoiceOptions[1],  
  },
  cause: causesOptions[4],
});